import React from 'react'
import R from 'ramda'

const getDisplayName = (WrappedComponent) => {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component'
}
const fun = (render) => {
  class StatelessFuncToPureComponent extends React.Component {
    shouldComponentUpdate(nextProps){
      return !R.equals(this.props, nextProps)
    }
    render(){
      return render(this.props)
    }
  }
  StatelessFuncToPureComponent.propTypes = render.propTypes
  StatelessFuncToPureComponent.defaultProps = render.defaultProps
  StatelessFuncToPureComponent.displayName = `StatelessFuncToPureComponent(${getDisplayName(render)})` 
  return StatelessFuncToPureComponent
}
export default fun



/** WEBPACK FOOTER **
 ** ./app/components/StatelessFuncToPureComponent.js
 **/